<script>
	import Box from "../components/Box.svelte";
	import { fade } from "svelte/transition";
	import MatrixText from '../components/MatrixText.svelte';

	let isVisible=false;
</script>

<svelte:head>
	<title>Damien ROCH | Senior Web Developer - Besancon, France</title>
</svelte:head>

<Box>
	<h1>
		<i class="fa-solid fa-terminal" /> Hello World,<br />
		I'm <strong><MatrixText value="Damien" on:terminate={()=>isVisible=true}/></strong>,<br />
		{#if isVisible}
			<span transition:fade> Senior Fullstack Web Developer </span>
		{/if}
	</h1>
</Box>